import {
  GenerationType,
  marketingAgentPromptScenarioSchema,
} from "@redotech/redo-marketing-templates-common/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const createScenarioInputSchema_ = z.object({
  smsTemplateId: zExt.objectId().optional(),
  generationType: z.enum([GenerationType.MANUAL, GenerationType.AI]),
  displayLabel: z.string(),
  displayDescription: z.string(),
  prompt: z.string(),
});
export interface CreateScenarioInput extends z.infer<
  typeof createScenarioInputSchema_
> {}
export const createScenarioInputSchema: z.ZodType<CreateScenarioInput> =
  createScenarioInputSchema_;

export const createScenario = {
  name: "createScenario" as const,
  input: createScenarioInputSchema,
  output: marketingAgentPromptScenarioSchema,
};
